// extracted by mini-css-extract-plugin
export var raddningsverket = "landing-module--raddningsverket--2nJFv";
export var bannerImage = "landing-module--bannerImage--3QGOG";
export var serviceLink = "landing-module--serviceLink--2DgLC";
export var alignCenter = "landing-module--alignCenter--1j_eB";
export var sectionPaddingTop = "landing-module--sectionPaddingTop--2O8pb";
export var sectionPaddingBottom = "landing-module--sectionPaddingBottom--1hRSl";
export var backgroundGreen = "landing-module--backgroundGreen--CmkF0";
export var inner = "landing-module--inner--2n5vg";
export var twoColGrid = "landing-module--twoColGrid--O6wUi";
export var textDarkblue = "landing-module--textDarkblue--1ZQGN";
export var subheading = "landing-module--subheading--cBWPu";
export var layer = "landing-module--layer--1gJBZ";
export var h2 = "landing-module--h2--3Fo84";
export var h3 = "landing-module--h3--1VG4m";
export var slickSlider = "landing-module--slickSlider--DfQv1";
export var usage = "landing-module--usage--1B_PF";
export var slideOuter = "landing-module--slideOuter--1R3Vp";
export var slide = "landing-module--slide--3aCm8";
export var image = "landing-module--image--38hAH";
export var text = "landing-module--text--3J9xk";
export var usageBoxes = "landing-module--usageBoxes--17xP9";
export var usageBox = "landing-module--usageBox--2vyfO";
export var usageBoxInformation = "landing-module--usageBoxInformation--2_blt";
export var bullet = "landing-module--bullet--C7jbp";
export var iconWrapper = "landing-module--iconWrapper--2jNNb";
export var bulletText = "landing-module--bulletText--1HrVN";
export var textBox_wrapper = "landing-module--textBox_wrapper--2QY7n";
export var textBox__inner = "landing-module--textBox__inner--137Ia";